import { render, staticRenderFns } from "./WineStockListModal.vue?vue&type=template&id=504508ed&scoped=true"
import script from "./WineStockListModal.vue?vue&type=script&lang=js"
export * from "./WineStockListModal.vue?vue&type=script&lang=js"
import style0 from "./WineStockListModal.vue?vue&type=style&index=0&id=504508ed&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504508ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504508ed')) {
      api.createRecord('504508ed', component.options)
    } else {
      api.reload('504508ed', component.options)
    }
    module.hot.accept("./WineStockListModal.vue?vue&type=template&id=504508ed&scoped=true", function () {
      api.rerender('504508ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/WineStockListModal.vue"
export default component.exports